import React from 'react'
import PropTypes from 'prop-types'
import { RaisedButton, Dialog } from 'material-ui'
import Wrapper from 'components/wrappers/Wrapper'
import ErrorOutline from 'material-ui/svg-icons/alert/error-outline'

const Alert = ({
  open,
  content,
  bodyStyle,
  contentStyle,
  actionsContainerStyle,
  onCancel,
  onSubmit,
  ...props
}) => {
  const actions = [
    <RaisedButton
      label={'Cancel'}
      primary
      style={{ marginRight: 20 }}
      onTouchTap={onCancel}
    />,
    <RaisedButton
      label={'Submit'}
      secondary
      onTouchTap={onSubmit}
    />,
  ];
  return (
    <Dialog
      open={open}
      modal={false}
      actions={actions}
      onRequestClose={onCancel}
      bodyStyle={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        ...bodyStyle,
      }}
      contentStyle={{
        width: 400,
        ...contentStyle,
      }}
      actionsContainerStyle={{
        display: 'flex',
        justifyContent: 'center',
        padding: 24,
        paddingTop: 0,
        ...actionsContainerStyle,
      }}
      {...props}
    >
      <ErrorOutline
        style={{
          width: 100,
          height: 100,
          color: '#d5d5d5',
        }}
      />
      <Wrapper mt={2} mb={1}>
        {content || 'Are you sure ?'}
      </Wrapper>
    </Dialog>
  )
}

Alert.propTypes = {
  content: PropTypes.node,
  ...Dialog.propTypes,
}
Alert.defaultProps = {
  content: null,
  ...Dialog.defaultProps,
}

export default Alert



// WEBPACK FOOTER //
// ./src/components/modals/Alert.js